export default function SectionHeader({ eyebrow, title, subtitle, align = 'left', light = false }) {
  return (
    <header className={`section-header section-header--${align} ${light ? 'section-header--light' : ''}`}>
      {eyebrow && <span className="section-header__eyebrow">{eyebrow}</span>}
      <h2 className="section-header__title">{title}</h2>
      {subtitle && <p className="section-header__subtitle">{subtitle}</p>}
    </header>
  );
}
